import { useEffect, useState } from 'react'
export default function CustomInputRange(props) {
  const { min, max, value, setValue} = props
  const [tooltipPos, setTooltipPos] = useState(0)
  const [tooltipValue, setTooltipValue] = useState(0)

  useEffect(() => {
    // console.log(value)
    if (value === '31') {
      setTooltipValue('30+')
    }
    else setTooltipValue(value)
    setTooltipPos(value / (max - min) * 290)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[value])

  return (
    <div className='customInputRange'>
      <div className='inputTooltipContainer' style={{left:tooltipPos}}>
        <div className='inputTooltip'>
          <div>{tooltipValue}</div>
        </div>
      </div>
      <div className='fillProgress' style={{width:tooltipPos*1.05}}></div>
      <input type='range' min={min} max={max} value={value} onChange={(e) => setValue(e.target.value)}/>
    </div>
  )
}